import $ from 'jquery';

class GalleryView {
  constructor($view) {
    this.$view = $view;
    this.slidesPerView = $view.data('gallery-view') || 3;
    this.init();
  }
  init() {
    const { $view } = this;
    const galleryView = $view[0];
    if (galleryView._galleryViewInit) return;
    galleryView._galleryViewInit = true;
    this.itemLen = $view.find('img').length;
    this.insertDOM();
  }
  insertDOM() {
    const { $view } = this;
    const $childrens = $view.children();
    $childrens.addClass('swiper-slide ratio ratio-3x2');
    $childrens.each((idx, el) => {
      if (el.dataset.caption) el.insertAdjacentHTML('afterbegin', '<i class="ri-align-left"></i>');
    });
    $view.wrapInner(
      $('<div class="swiper swiper--gallery"><div class="swiper-wrapper"></div></div>'),
    );
    $view.find('img').addClass('swiper-lazy');
    $view.find('.swiper--gallery').swiper({
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 12,
      breakpoints: {
        320: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        1024: {
          slidesPerView: this.slidesPerView,
          slidesPerGroup: this.slidesPerView,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next icon-btn icon-btn--white d-none--nohover',
        prevEl: '.swiper-button-prev icon-btn icon-btn--white d-none--nohover',
      },
      scrollbar: {
        el: '.swiper-scrollbar d-none--hashover',
      },
      lazy: {
        loadPrevNext: true,
      },
    });
  }
}

$('[data-gallery-view]').each(function () {
  new GalleryView($(this));
});
